import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import type { RailGroup } from '@/pages/settings/sections';

/**
 * De instellingen-navigatie. Eén onderwerp per scherm.
 *
 * Was een scrollspy over één pagina van 4.497 pixels: je klikte op "Webshop"
 * en de pagina sprong ergens heen, waarna je zelf moest bijhouden waar je was.
 * Nu is elk kopje een scherm, en de gekozen sectie staat in de URL (`?s=`), dus
 * verversen en een link delen komen allebei op dezelfde plek uit.
 */
export function SettingsRail({
  groups,
  current,
  onSelect,
}: {
  groups: RailGroup[];
  current: string;
  onSelect: (id: string) => void;
}) {
  const { t } = useTranslation();

  return (
    <nav
      className="settings-secnav"
      style={{ position: 'sticky', top: 84, display: 'flex', flexDirection: 'column', gap: 1 }}
    >
      {groups.map((g, gi) => (
        <Fragment key={g.key}>
          <div
            className="font-mono text-text-muted uppercase"
            style={{ fontSize: 10, letterSpacing: '0.06em', padding: gi === 0 ? '2px 10px 6px' : '14px 10px 6px' }}
          >
            {t(`settings.group.${g.key}`)}
          </div>
          {g.items.map((it) => {
            const isActive = current === it.id;
            return (
              <button
                key={it.id}
                type="button"
                onClick={() => onSelect(it.id)}
                aria-current={isActive ? 'page' : undefined}
                className={`${isActive ? 'text-text-primary bg-bg-tertiary' : 'text-text-secondary hover:text-text-primary'} hover:bg-(--hover-overlay)`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '7px 10px',
                  borderRadius: 4,
                  border: 0,
                  borderLeft: `2px solid ${isActive ? 'var(--accent)' : 'transparent'}`,
                  background: isActive ? undefined : 'transparent',
                  font: 'inherit',
                  fontSize: 13.5,
                  fontWeight: isActive ? 500 : 400,
                  textAlign: 'left',
                  cursor: 'pointer',
                }}
              >
                {t(`settings.nav.${it.key}`)}
              </button>
            );
          })}
        </Fragment>
      ))}
    </nav>
  );
}
